import { required, minLength } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  description: {
    required,
    minLength: minLength(2)
  },
  shortDescription: {
    required,
  },
};

export default validations;